import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Blog from './components/Blog';
import PostDetail from './components/PostDetail';

//ログイン関係ファイル
import { AuthProvider } from "./context/AuthContext";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./components/Dashboard";
import CreateArticle from "./components/CreateArticle";
import EditArticle from "./components/EditArticle";
import EditArticleForm from "./components/EditArticleForm";
import DeleteArticle from "./components/DeleteArticle";


function App() {
  return (
    // <Router>
    <AuthProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<Blog />} />
          <Route path="/archive/:ym" element={<Blog />} />  
          <Route path="/category/:cat" element={<Blog />} />  
          <Route path="/post/:id" element={<PostDetail />} />

          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<ProtectedRoute />}>
            <Route index element={<Dashboard />} />
            <Route path="create-article" element={<CreateArticle />} />
            <Route path="edit-article" element={<EditArticle />} />
            <Route path="edit-article/:id" element={<EditArticleForm />} />
            <Route path="delete-article" element={<DeleteArticle />} />
          </Route>

        </Routes>
      </div>
    {/* </Router> */}
    </AuthProvider>
  );
}

export default App;